import { GrayColors } from "@smartsuite/react-ui";
import styled from "styled-components";

export const Wrapper = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 10px;

  background: ${GrayColors["G-0-5"]};
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 5px;
  cursor: pointer;
`;

export const Text = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: inline;
  margin-left: 10px;
`;

export const VerticalLine = styled.div`
  border-left: 1px solid ${GrayColors["G-1-5"]};
  height: 32px;
  right: 35px;
  position: absolute;
`;

export const Space = styled.div`
  width: 18px;
`;

export const OnOffWrapper = styled.div`
  display: flex;
`;
